import {
  base_colorAction,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_md,
  fontH1,
  fontH3,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const wrapper = css`
  display: flex;
  flex-direction: column;
`

export const identityRow = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2.5)};
`

export const cardholderName = css`
  ${fontH3};
  color: ${text_colorTextPrimary};
  margin: 0;
`

export const metaRow = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  margin-top: ${spacing(1)};
  flex-wrap: wrap;
`

export const metaText = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const nicknameTrigger = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1)};
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: ${text_colorTextSecondary};
  cursor: pointer;

  @media (prefers-reduced-motion: no-preference) {
    transition: color 150ms ease;
  }

  &:hover,
  &:focus-visible {
    color: ${base_colorAction};
  }

  &:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 2px;
  }
`

export const creditBlock = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  margin-top: ${spacing(8)};
`

export const creditLabel = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const creditAmount = css`
  ${fontH1};
  color: ${text_colorTextPrimary};
  font-variant-numeric: tabular-nums;
`

export const creditLimit = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

/**
 * Surrogate-backed limits are really persisted and really versioned, but they
 * are not real issuer balances. The caveat is plain text, not a colour or an
 * icon, so it survives for every user.
 */
export const creditProvenance = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`
